/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from 'react'
import { getRequestOptions } from '../helpers/Fetchwrapper';
import { KTSVG } from '../../_metronic/helpers';
import { Col, Row, Table } from 'react-bootstrap-v5';
import 'react-dropzone-uploader/dist/styles.css'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone-uploader'
import Swal from 'sweetalert2'
import showLoader from '../helpers/ShowLoader';
import axios, { AxiosResponse, AxiosError } from 'axios'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { AppContext } from '../context/AppContext'

interface PurchaseInfo {
    id_purchase: number;
    id_projects: number;
    id_vendors: number;
    purchaseType: string;
    purchaseDate: string;
    referenceNo: string;
    lcNo: string;
    invoiceNo?: string;
    chalanNo: string;
    chalanDate: string;
    remarks: string;
    purchaseAmount: number;
    itemAmount?: number;
    vat?: number;
    tax?: number;
    vatAmount?: number;
    taxAmount?: number;
    vatType?: 'percentage' | 'flat';
    taxType?: 'percentage' | 'flat';
    created_by: number;
    createdAt: string;
    project: {
        id_projects: number;
        projectName: string;
    };
    warehouse: { id_warehouses: number, name: string, address: string, details: string };
    vendor: { id_vendors: number, vendorName: string, phone: string, address: string };
    voucher: { id_acc_vouchers: number, voucherNo: string, voucherDate: string, voucherType: string };
    rows: { id_purchase: number, id_items: number, rate: number, quantity: number, returnQuantity: number, item: any }[];
    files: { id_ref: number, refType: string, attachmentName: string, attachmentPath: string, fileSize: number, created_at: string, creator: any }[];
    creator: any;
    status: string;
}

interface RouteParams {
    idPurchase: string;
}

interface PurchaseHistoryChange {
    field: string;
    from: string | null;
    to: string | null;
}

interface CascadeImpactRecord {
    id: number;
    label: string;
    from: Record<string, string | null>;
    to: Record<string, string | null>;
}

interface CascadeImpact {
    replayFromDate?: string;
    affectedItemIds?: number[];
    summary?: Record<string, number>;
    productionMaterials?: CascadeImpactRecord[];
    productionRows?: CascadeImpactRecord[];
    productions?: CascadeImpactRecord[];
    shipmentRows?: CascadeImpactRecord[];
    shipmentFreeRows?: CascadeImpactRecord[];
    shipments?: CascadeImpactRecord[];
    averageRates?: CascadeImpactRecord[];
}

interface PurchaseHistoryEntry {
    id: number;
    action: string;
    createdAt: string;
    userName: string | null;
    referenceLabel: string | null;
    changes: PurchaseHistoryChange[];
    cascadeImpact: CascadeImpact | null;
    replayFromDate?: string | null;
}

const getActivityStyle = (action: string) => {
    switch (action) {
        case 'Purchase Updated':
            return { badge: 'badge-light-info', icon: '/media/svg/icons/Communication/Write.svg', iconBg: 'bg-light-info' };
        default:
            return { badge: 'badge-light-secondary', icon: '/media/svg/icons/General/Clipboard.svg', iconBg: 'bg-light-secondary' };
    }
};

const formatActivityDate = (dateTime: string) => {
    if (!dateTime) {
        return '';
    }

    const date = new Date(dateTime.replace(' ', 'T'));
    if (Number.isNaN(date.getTime())) {
        return dateTime;
    }

    return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
};

const renderImpactRecords = (title: string, records?: CascadeImpactRecord[]) => {
    if (!records || records.length === 0) {
        return null;
    }

    return (
        <div className="mb-3">
            <div className="fw-semibold fs-7 mb-2">{title}</div>
            <Table striped bordered hover size="sm" className="mb-0">
                <thead>
                    <tr>
                        <th>Record</th>
                        <th>From</th>
                        <th>To</th>
                    </tr>
                </thead>
                <tbody>
                    {records.map((record) => (
                        <tr key={`${title}-${record.id}`}>
                            <td>{record.label}</td>
                            <td className="text-muted">{JSON.stringify(record.from)}</td>
                            <td className="fw-semibold">{JSON.stringify(record.to)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export function PurchaseDetails(props: any) {

    const { currentUser } = useContext(AppContext);
    const [purchaseInfo, setPurchaseInfo] = useState<PurchaseInfo | null>(null);
    const [histories, setHistories] = useState<PurchaseHistoryEntry[]>([]);
    const [expandedActivityIds, setExpandedActivityIds] = useState<number[]>([]);
    const { idPurchase }: RouteParams = useParams();

    useEffect(() => {
        if (idPurchase !== undefined) {
            getPurchaseInfo();
        }
    }, [idPurchase])

    const getPurchaseInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'purchase/' + idPurchase,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const data: PurchaseInfo = resp.data;
                setPurchaseInfo(data);
                setHistories(resp.histories ?? []);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    const numberFormat = (value: any) => {

        value = parseFloat(value)
        if (typeof (value) !== 'number') {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }


    const getReadableFileSizeString = (fileSizeInBytes: number) => {
        return ((fileSizeInBytes / (1024 * 1024)).toFixed(4) + " MB");
    }

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return (myToken != null) ? JSON.parse(myToken) : null;
    }

    const handleFileSubmit = (files: any, allFiles: []) => {
        showLoader()

        const postFormData = new FormData();
        postFormData.append('idRef', idPurchase.toString());
        postFormData.append('refType', 'goods_receive');
        postFormData.append('folderPath', 'goods-receives');
        for (let i = 0; i < files.length; i++) {
            postFormData.append('files[]', files[i].file);
        }

        const url: string = `${process.env.REACT_APP_API_URL}file/upload`;

        axios({
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + jwt(),
            },
            data: postFormData,
        })
            .then((response: AxiosResponse<any>) => {
                Swal.close();
                allFiles.forEach((f: any) => f.remove());
                getPurchaseInfo();
            })
            .catch((error: AxiosError<any>) => {
                Swal.close();
                // const errorMessage: string = error.response?.data?.errorMessage;
                const errorsMessage: string = validationErrorMsg(error?.response?.data?.errors).join('<br>');
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: errorsMessage,
                });
            });

    }


    const toggleActivityChanges = (activityId: number) => {
        setExpandedActivityIds((current) =>
            current.includes(activityId)
                ? current.filter((id) => id !== activityId)
                : [...current, activityId]
        );
    };

    return (<>
        <div className='card card-custom'>
            <div className='card-header card-header-stretch overflow-auto'>
                <div className='card-title'>
                    <h3 className='card-label'>Goods Received Details</h3>
                    <small className='text-muted'>| Information about the Goods Received</small>
                </div>
            </div>
            <div className="card-body">

            </div>
        </div>
        <Row>
            <Col md={4} className="pe-2">
                <div className="card card-flush overflow-hidden mt-3 ms-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Summary</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size='sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>ID</td>
                                    <td style={{ width: '50%' }}>{purchaseInfo?.id_purchase}</td>
                                </tr>
                                <tr>
                                    <td>Receive Type</td>
                                    <td>
                                        {
                                            purchaseInfo?.purchaseType === 'LC' ?
                                                <span className="badge badge-primary">LC</span>

                                                :
                                                <span className="badge badge-success">Local Purchase</span>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>PO Purpose</td>
                                    <td>
                                        <span className={`badge ${purchaseInfo?.po?.purpose === 'Finished Product' ? 'badge-info' : 'badge-success'}`}>
                                            {purchaseInfo?.po?.purpose || 'Raw Materials'}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Project</td>
                                    <td>{purchaseInfo?.project?.projectName}</td>
                                </tr>
                                <tr>
                                    <td>Warehouse</td>
                                    <td>{purchaseInfo?.warehouse?.name}</td>
                                </tr>
                                <tr>
                                    <td>Vendor</td>
                                    <td>{purchaseInfo?.vendor?.vendorName}</td>
                                </tr>
                                <tr>
                                    <td>Receive Date </td>
                                    <td>{purchaseInfo?.purchaseDate}</td>
                                </tr>
                                <tr>
                                    <td>Reference No </td>
                                    <td>{purchaseInfo?.referenceNo}</td>
                                </tr>
                                {
                                    purchaseInfo?.purchaseType === 'LC' && (
                                        <>
                                            <tr>
                                                <td>LC No</td>
                                                <td>{purchaseInfo?.lcNo}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice No</td>
                                                <td>{purchaseInfo?.invoiceNo}</td>
                                            </tr>
                                        </>
                                    )
                                }

                                <tr>
                                    <td>Chalan No</td>
                                    <td>{purchaseInfo?.chalanNo}</td>
                                </tr>
                                <tr>
                                    <td>Chalan Date</td>
                                    <td>{purchaseInfo?.chalanDate}</td>
                                </tr>
                                <tr>
                                    <td>Voucher No </td>
                                    <td>
                                        <span>{purchaseInfo?.voucher?.voucherNo} </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Status </td>
                                    <td>
                                        {purchaseInfo?.status === 'approved' && <span className="badge badge-success">Approved</span>}
                                        {purchaseInfo?.status === 'created' && <span className="badge badge-warning">Pending for Accountant Approval</span>}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Remarks</td>
                                    <td>{purchaseInfo?.remarks}</td>
                                </tr>
                                <tr>
                                    <td>Creator</td>
                                    <td>{purchaseInfo?.creator.firstName + ' ' + purchaseInfo?.creator.lastName + ' at ' + purchaseInfo?.createdAt}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className='card card-flush overflow-hidden mt-3 ms-2'>
                    <div className='card-header py-5'>
                        <h3 className="card-title">
                            <KTSVG className='svg-icon-3 me-2' path="/media/svg/icons/General/Clip.svg"></KTSVG>
                            Attach files
                        </h3>
                    </div>


                    <div className='card-body'>
                        <Table striped bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th style={{ width: '50%' }}>Attachment</th>
                                    <th style={{ width: '50%' }}>Uploaded By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchaseInfo?.files?.length === 0 &&
                                    <tr>
                                        <td colSpan={2}>No File Attached</td>
                                    </tr>
                                }
                                {purchaseInfo?.files?.map((attachment, index) => (
                                    <tr>
                                        <td key={'attachment' + index}>
                                            <a rel='noreferrer' href={process.env.REACT_APP_AWS_URL + "goods-receives/" + attachment.attachmentPath}
                                                className="fs-6 text-hover-primary fw-bold" target="_blank">{attachment.attachmentName}</a>
                                            <div className="text-gray-400">{getReadableFileSizeString(attachment.fileSize)}</div>
                                        </td>
                                        <td>{attachment.creator.firstName + ' ' + attachment.creator.lastName + ' at ' + attachment.createdAt}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <Dropzone
                            styles={{ dropzone: { border: "none" } }}
                            accept='image/*,audio/*,application/pdf'
                            onSubmit={handleFileSubmit}
                        />
                    </div>
                </div>
            </Col>
            <Col md={8} className="pt-2">

                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">
                                {purchaseInfo?.po?.purpose === 'Finished Product' ? 'Products' : 'Items'}
                            </span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>SL No</th>
                                    <th>{purchaseInfo?.po?.purpose === 'Finished Product' ? 'Product' : 'Item'}</th>
                                    <th>{purchaseInfo?.po?.purpose === 'Finished Product' ? 'Product Code' : 'Item Code'}</th>
                                    <th>{purchaseInfo?.po?.purpose === 'Finished Product' ? 'Packing' : 'Item Category'}</th>
                                    <th className='text-center'>Received Quantity</th>
                                    <th className='text-center'>Returned Quantity</th>
                                    {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                        <>
                                            <th className='text-center'>Rate</th>
                                            <th className='text-center'>Amount</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>

                                {purchaseInfo?.rows?.map((purchaseItem, index) => {
                                    const isFinishedProduct = purchaseInfo?.po?.purpose === 'Finished Product';
                                    const displayName = isFinishedProduct
                                        ? (purchaseItem?.product?.productName || purchaseItem?.item?.itemName || '')
                                        : (purchaseItem?.item?.itemName || '');
                                    const displayCode = isFinishedProduct
                                        ? (purchaseItem?.product?.productCode || '')
                                        : (purchaseItem?.item?.itemCode || '');
                                    const displayMeta = isFinishedProduct
                                        ? (purchaseItem?.product?.packing || '')
                                        : (purchaseItem?.item?.item_category?.categoryName || purchaseItem?.item?.itemCategory?.categoryName || '');
                                    const unitName = isFinishedProduct
                                        ? (purchaseItem?.product?.item?.unit?.unitName || purchaseItem?.item?.unit?.unitName || '')
                                        : (purchaseItem?.item?.unit?.unitName || '');

                                    return (
                                    <tr key={'item' + index}>
                                        <td>{index + 1}</td>
                                        <td>{displayName}</td>
                                        <td>{displayCode}</td>
                                        <td>{displayMeta}</td>
                                        <td className='text-center'>
                                            <span className="badge badge-light-danger"> {Number(purchaseItem?.quantity) + ' ' + unitName}</span>
                                        </td>
                                        <td className='text-center'>
                                            <span className="badge badge-light-warning"> {Number(purchaseItem?.returnQuantity || 0) + ' ' + unitName}</span>
                                        </td>
                                        {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                            <>
                                                <td className='text-end'>{Number(purchaseItem?.rate)}</td>
                                                <td className='text-end'>{numberFormat(purchaseItem?.quantity * purchaseItem?.rate)}</td>
                                            </>
                                        )}
                                    </tr>
                                    );
                                })}
                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                    <tr>
                                        <td colSpan={7} className='text-end'><b>Total Amount : </b></td>
                                        <td className='text-end'><b>{numberFormat(Number(purchaseInfo?.itemAmount || purchaseInfo?.purchaseAmount))}</b></td>
                                    </tr>
                                )}
                            </tbody>

                        </Table>
                        <div className='row mt-4'>
                            <div className='col-6'></div>
                            <div className='col-6'>
                                {(Number(purchaseInfo?.vatAmount || 0) > 0 || Number(purchaseInfo?.taxAmount || 0) > 0) && (
                                    <div className='notice bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6'>
                                        <div className="row mt-2">
                                            <div className="col-md-8 text-end"><strong>Total Amount: </strong></div>
                                            <div className="col-md-4 text-end">
                                                {numberFormat(purchaseInfo?.itemAmount || purchaseInfo?.purchaseAmount)}
                                            </div>
                                        </div>
                                        {Number(purchaseInfo?.vatAmount || 0) > 0 && (
                                            <div className="row mt-2">
                                                <div className="col-md-8 text-end"><strong>VAT ({purchaseInfo.vatType === 'flat' ? 'Flat' : purchaseInfo.vat + '%'}): </strong></div>
                                                <div className="col-md-4 text-end">
                                                    {numberFormat(purchaseInfo.vatAmount || 0)}
                                                </div>
                                            </div>
                                        )}
                                        {Number(purchaseInfo?.taxAmount || 0) > 0 && (
                                            <div className="row mt-2">
                                                <div className="col-md-8 text-end"><strong>TAX ({purchaseInfo.taxType === 'flat' ? 'Flat' : purchaseInfo.tax + '%'}): </strong></div>
                                                <div className="col-md-4 text-end">
                                                    {numberFormat(purchaseInfo.taxAmount || 0)}
                                                </div>
                                            </div>
                                        )}
                                        <div className="row mt-2">
                                            <div className="col-md-8 text-end"><strong>Net Amount: </strong></div>
                                            <div className="col-md-4 text-end">
                                                {numberFormat(purchaseInfo?.purchaseAmount || 0)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col text-center'>

                                <Link className="btn btn-info btn-sm" to={`/purchase`}>
                                    <KTSVG
                                        path='/media/svg/icons/Media/Back.svg'
                                        className='svg-icon-5 svg-icon'
                                    />		Back to Goods Receive List
                                </Link>

                            </div>
                        </div>

                    </div>
                </div>
            </Col>
        </Row>

        <Row>
            <Col md={12} className="pt-2">
                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">
                                <KTSVG className='svg-icon-4 me-2' path="/media/svg/icons/General/Clipboard.svg" />
                                Edit History
                            </span>
                            <small className="text-muted fw-normal mt-1">
                                Goods receive updates and downstream cascade impact
                            </small>
                        </h3>
                        {histories.length > 0 && (
                            <div className="card-toolbar">
                                <span className="badge badge-light-primary fs-7">
                                    {histories.length} edit(s)
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="card-body pt-0">
                        {histories.length === 0 ? (
                            <div className="text-center py-8 text-muted">
                                <KTSVG className='svg-icon-3x text-gray-400 mb-3' path="/media/svg/icons/General/Clipboard.svg" />
                                <div className="fw-semibold fs-6">No edit history yet</div>
                                <small>Updates to this goods receive will appear here</small>
                            </div>
                        ) : (
                            <div className="d-flex flex-column gap-3">
                                {histories.map((activity, index) => {
                                    const style = getActivityStyle(activity.action);
                                    const isExpanded = expandedActivityIds.includes(activity.id);
                                    const changes = activity.changes ?? [];
                                    const cascadeImpact = activity.cascadeImpact;
                                    const hasCascadeImpact = cascadeImpact && (
                                        (cascadeImpact.productionMaterials?.length ?? 0) > 0
                                        || (cascadeImpact.productionRows?.length ?? 0) > 0
                                        || (cascadeImpact.productions?.length ?? 0) > 0
                                        || (cascadeImpact.shipmentRows?.length ?? 0) > 0
                                        || (cascadeImpact.shipmentFreeRows?.length ?? 0) > 0
                                        || (cascadeImpact.shipments?.length ?? 0) > 0
                                        || (cascadeImpact.averageRates?.length ?? 0) > 0
                                    );

                                    return (
                                        <div className="p-4 rounded border border-gray-200 bg-white" key={activity.id ?? index}>
                                            <div className="d-flex align-items-start">
                                                <div className={`symbol symbol-40px symbol-circle me-4 flex-shrink-0 ${style.iconBg}`}>
                                                    <span className="symbol-label">
                                                        <KTSVG path={style.icon} className="svg-icon-2 svg-icon-primary" />
                                                    </span>
                                                </div>
                                                <div className="flex-grow-1 min-w-0">
                                                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                                                        <span className={`badge ${style.badge} fs-7`}>{activity.action}</span>
                                                        {activity.referenceLabel &&
                                                            <span className="text-gray-800 fw-semibold fs-7">{activity.referenceLabel}</span>
                                                        }
                                                    </div>
                                                    {activity.userName &&
                                                        <div className="text-gray-600 fs-7">
                                                            By <span className="fw-semibold text-gray-800">{activity.userName}</span>
                                                        </div>
                                                    }
                                                    {(changes.length > 0 || hasCascadeImpact) ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link btn-sm p-0 mt-1 fs-7"
                                                            onClick={() => toggleActivityChanges(activity.id)}
                                                        >
                                                            {isExpanded ? 'Hide' : 'View'} details
                                                        </button>
                                                    ) : (
                                                        <div className="text-muted fs-8 mt-1">No field changes recorded</div>
                                                    )}
                                                </div>
                                                <div className="text-end text-muted fs-7 flex-shrink-0 ps-3" style={{ minWidth: '130px' }}>
                                                    {formatActivityDate(activity.createdAt)}
                                                </div>
                                            </div>
                                            {isExpanded && (
                                                <>
                                                    {changes.length > 0 && (
                                                        <>
                                                            <div className="fw-semibold fs-7 mt-3 mb-2">Purchase changes</div>
                                                            <Table striped bordered hover size="sm" className="mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '34%' }}>Field</th>
                                                                        <th style={{ width: '33%' }}>From</th>
                                                                        <th style={{ width: '33%' }}>To</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {changes.map((change, changeIndex) => (
                                                                        <tr key={`change-${activity.id}-${changeIndex}`}>
                                                                            <td>{change.field}</td>
                                                                            <td className="text-muted">{change.from ?? '-'}</td>
                                                                            <td className="fw-semibold">{change.to ?? '-'}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </>
                                                    )}
                                                    {hasCascadeImpact && (
                                                        <div className="mt-4">
                                                            <div className="fw-semibold fs-7 mb-2">
                                                                Cascade impact from {cascadeImpact?.replayFromDate}
                                                            </div>
                                                            {cascadeImpact?.summary && (
                                                                <div className="text-muted fs-8 mb-3">
                                                                    Production materials: {cascadeImpact.summary.productionMaterialRows ?? 0}
                                                                    {' | '}Production rows: {cascadeImpact.summary.productionRows ?? 0}
                                                                    {' | '}Manufacturing: {cascadeImpact.summary.productions ?? 0}
                                                                    {' | '}Shipment rows: {cascadeImpact.summary.shipmentRows ?? 0}
                                                                    {' | '}Shipments: {cascadeImpact.summary.shipments ?? 0}
                                                                    {' | '}Manufacturing vouchers: {cascadeImpact.summary.manufacturingVouchers ?? 0}
                                                                    {' | '}Shipment vouchers: {cascadeImpact.summary.shipmentVouchers ?? 0}
                                                                </div>
                                                            )}
                                                            {renderImpactRecords('Production materials', cascadeImpact?.productionMaterials)}
                                                            {renderImpactRecords('Production rows', cascadeImpact?.productionRows)}
                                                            {renderImpactRecords('Manufacturing', cascadeImpact?.productions)}
                                                            {renderImpactRecords('Shipment rows', cascadeImpact?.shipmentRows)}
                                                            {renderImpactRecords('Free shipment rows', cascadeImpact?.shipmentFreeRows)}
                                                            {renderImpactRecords('Shipments', cascadeImpact?.shipments)}
                                                            {renderImpactRecords('Average rates', cascadeImpact?.averageRates)}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </Col>
        </Row>
    </>
    )
}

export default PurchaseDetails
